export const AI = ({ color = 'white' }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="22" height="22" rx="3" fill={color} fill-opacity="0.1" />
            <rect x="1" y="1" width="22" height="22" rx="3" stroke={color} stroke-width="2" />
            <path d="M8.09286 16H6.11559L9.12837 7.27273H11.5062L14.5147 16H12.5375L10.3514 9.26705H10.2832L8.09286 16ZM7.96928 12.5696H12.6397V14.0099H7.96928V12.5696ZM17.4103 7.27273V16H15.5652V7.27273H17.4103Z" fill={color} />
        </svg>
    )
}
